<ng-container *ngIf="fieldTypeSpecs; else loadingTemplate">
  <div class="d-flex justify-content-between">
    <div class="input-group">
      <label for="number-of-levels" class="form-label me-3 fs-11"
        >Number of Levels:</label
      >
      <input
        id="number-of-levels"
        type="number"
        min="2"
        [max]="levelsMax"
        class="form-control level-input"
        style="max-width: 50px"
        [ngModel]="fieldTypeSpecs.numbLevels"
        (ngModelChange)="onLevelsValueChange($event)" />
    </div>
    <button
      class="btn-reset fw-600 fs-11 ms-4"
      style="white-space: nowrap"
      (click)="editLevelNamesModal.modal.open()">
      <i class="bi bi-pencil color-tertiary fs-12 me-1"></i> Edit Level Names
    </button>
    <app-edit-level-names-modal
      [levelNames]="fieldTypeSpecs.levelNames"
      (levelsUpdated)="handleLevelNamesEvent($event)"
      #editLevelNamesModal></app-edit-level-names-modal>
  </div>
  <div class="p-2">
    <ng-container
      *ngFor="let competency of fieldTypeSpecs.competencies; index as ci">
      <div class="comptency-wrapper mt-3">
        <div class="d-flex mb-3">
          <div class="d-flex align-items-center custom-input-group flex-grow-1">
            <app-proforms-rubric-competency-title
              [title]="competency.title"
              [currentTitleBeingEdited]="currentTitleBeingEdited"
              (handleSaveEvent)="onTitleChange(competency, $event)"
              (handleTitleClicked)="setCurrentTitleBeingEdited($event)" />
          </div>
          <ng-container *ngIf="fieldTypeSpecs.competencies.length > 1">
            <button
              class="btn btn-delete fs-13"
              type="button"
              #tooltip="ngbTooltip"
              (click)="tooltip.close()"
              [ngbPopover]="deletePopoverContent"
              [autoClose]="'outside'"
              ngbTooltip="Delete Competency"
              #popover="ngbPopover">
              <i class="bi bi-trash"></i>
            </button>
            <ng-template #deletePopoverContent>
              Delete this competency?
              <div class="text-end mt-2">
                <button
                  type="button"
                  class="btn btn-secondary btn-sm px-3 m-1"
                  (click)="popover.close()">
                  No
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-sm px-3 m-1"
                  (click)="deleteCompetency(competency); popover.close()">
                  Yes
                </button>
              </div>
            </ng-template>
          </ng-container>
        </div>

        <div style="position: relative; margin-bottom: 20px">
          <div class="levels-wrapper">
            <ng-container *ngFor="let gi of competency.gis; index as l">
              <div class="level-item">
                <div class="level-header">
                  {{ fieldTypeSpecs.levelNames[l] }}
                </div>
                <div class="level-content">
                  {{ gi }}
                </div>
              </div>
            </ng-container>
          </div>
          <div
            class="edit-overlay"
            (click)="editCompetencyGiModal.modal.open()">
            <div class="icon-wrapper">
              <i class="bi bi-pencil me-1"></i>
            </div>
            <app-edit-gi-content-modal
              [levelNames]="fieldTypeSpecs.levelNames"
              [competencyTitle]="competency.title"
              [competencyGis]="competency.gis"
              [competencyIndex]="ci"
              (competencyGisUpdated)="handleGIsContentEvent($event)"
              #editCompetencyGiModal></app-edit-gi-content-modal>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="text-end">
      <button
        (click)="addCompetency()"
        type="button"
        class="btn btn-link fw-bold xp-0 text-decoration-none">
        <i class="bi bi-plus"></i>Add Competency
      </button>
    </div>
  </div>
</ng-container>
<ng-template #loadingTemplate>
  <div class="w-100" style="height: 200px; position: relative">
    <app-loader />
  </div>
</ng-template>
